import { composeClassNames } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import constants from "src/constants";
import {
  default as ChevronCircleLeft,
  default as ChevronCircleRight,
} from "src/icons/Chevron-circle-left";
import {
  default as ChevronCircleLeftFull,
  default as ChevronCircleRightFull,
} from "src/icons/Chevron-circle-left-full";
import { sSliderArrow } from "src/styles/sSliderArrow.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  direction?: "prev" | "next";
  onClick?: (() => void) | null | undefined;
};

function SliderArrow({ style, className, onClick, direction }: Props) {
  return (
    <div
      onClick={onClick}
      style={style}
      className={composeClassNames([sSliderArrow, className, "slider-arrow"])}
    >
      {direction === "next" ? (
        <>
          <ChevronCircleRight size={32} color={constants.Theme.greyLight} />
          <span className={`arrow-hover`}>
            <ChevronCircleRightFull
              size={32}
              color={constants.Theme.greyLight}
            />
          </span>
        </>
      ) : (
        <>
          <ChevronCircleLeft size={32} color={constants.Theme.greyLight} />
          <span className={`arrow-hover`}>
            <ChevronCircleLeftFull
              size={32}
              color={constants.Theme.greyLight}
            />
          </span>
        </>
      )}
    </div>
  );
}

export default SliderArrow;
